<template lang="html">
    <div class="previewSQR-page">
        <Slogan theTitle="申请人"/>
        <template v-if="sqr && sqr.length">
            <van-cell-group class="sqr-box" v-for="(item, index) in this.sqr"
                            :key="index">
                <van-field
                    v-model="item.cSqrlx"
                    readonly
                    label="申请人类型"
                ></van-field>
                <van-field
                    v-if="item.cSqrlx1 == 1"
                    v-model="item.cSqrxm"
                    clearable
                    readonly
                    label="姓名"
                ></van-field>
                <van-field
                    v-if="item.cSqrlx1 != 1"
                    v-model="item.cQymc"
                    clearable
                    readonly
                    label="单位名称"
                    @click="toastJointCcxx(item.cQymc)"
                ></van-field>
                <!--            <van-field
                                    v-if="item.cSqrlx1 != 1"
                                    v-model="item.cQyzzjgdm"
                                    clearable
                                    readonly
                                    class="special-xydm"
                                    label="统一社会信用代码"
                                    @click="toastJointCcxx(item.cQyzzjgdm)"
                            ></van-field>-->
                <van-field
                    v-if="item.cSqrlx1 != 1"
                    v-model="item.nZzlxText"
                    clearable
                    readonly
                    label="证照类型"
                    @click="toastJointCcxx(item.nZzlxText)"
                ></van-field>
                <van-field
                    v-if="item.cSqrlx1 != 1"
                    v-model="item.cQyzzjgdm"
                    clearable
                    readonly
                    label="证照号码"
                    @click="toastJointCcxx(item.cQyzzjgdm)"
                ></van-field>

                <van-field
                    v-if="item.cSqrlx1 == 2"
                    v-model="item.cDwxz"
                    clearable
                    readonly
                    label="单位性质"
                ></van-field>
                <van-field
                    v-if="item.cSqrlx1 == 3"
                    v-model="item.cDwxz"
                    clearable
                    readonly
                    label="单位性质"
                ></van-field>
                <van-field
                    v-if="item.cSqrlx1 != 1"
                    v-model="item.cQyfr"
                    clearable
                    readonly
                    label="法定代表人"
                ></van-field>
                <van-field
                    v-if="item.cSqrlx1 == 1"
                    v-model="item.cSqrxb"
                    readonly
                    label="性别"
                ></van-field>
                <van-field
                    v-if="item.cSqrlx1 == 1"
                    v-model="item.nMz"
                    readonly
                    clickable
                    label="民族"
                ></van-field>
                <van-field
                    v-if="item.cSqrlx1 == 1"
                    v-model="item.nNl"
                    readonly
                    clickable
                    label="年龄"
                ></van-field>
                <van-field
                    v-if="item.cSqrlx1 == 1"
                    v-model="item.dtSqrBirthday"
                    readonly
                    clickable
                    label="出生日期"
                ></van-field>
                <van-field
                    v-if="item.cSqrlx1 == 1"
                    v-model="item.cZjlx"
                    readonly
                    label="证件类型"
                    class="amount-ipt"
                    @click="toastJointCcxx(item.cZjlx)"
                ></van-field>
                <van-field
                    v-if="item.cSqrlx1 == 1"
                    v-model="item.cZjh"
                    readonly
                    label="证件号码"
                    @click="toastJointCcxx(item.cZjh)"
                ></van-field>
                <van-field
                    v-model="item.cPhoneno"
                    readonly
                    label="手机号码"
                    class="amount-ipt"
                ></van-field>
                <van-field
                    v-model="item.cGh"
                    readonly
                    class="amount-ipt"
                    label="固定电话"
                ></van-field>
                <van-field
                    v-if="item.cSqrlx1 == 1"
                    v-model="item.cTxdz"
                    readonly
                    label="经常居住地"
                    @click="toastJointCcxx(item.cTxdz)"
                ></van-field>
                <van-field
                    v-if="item.cSqrlx1 != 1"
                    v-model="item.cTxdz"
                    readonly
                    label="单位地址"
                    @click="toastJointCcxx(item.cTxdz)"
                ></van-field>
            </van-cell-group>
        </template>
        <!--        暂无数据的提示 -->
        <p v-else class="fd-empty-tips">暂无数据</p>
    </div>
</template>

<script>
    import Slogan from '../../../components/common/slogan'
    import { Toast } from 'vant';
    import {typeXb, typeRylx, typeSfzjlx, typeGzdwlx, typeSqr, typeMz, typeZzlx} from '../../../filters/index'

    export default {
        components: {
            Slogan
        },
        // 注入
        inject: ['bqid'],
        data() {
            return {
                sqr: [],
                Sfzjlx: "",
                sqrlx: "",
                sqrlx2:"",
                sqrlx3:"",
                mz: "",
                dwxz1: "",
                dwxz2: ""
            }
        },

        methods: {
            toastJointCcxx(value){
                Toast(value);
            },
            getSqrList() {
                this.$axios.get('ssbq/api/sqrsxq' + "?time=" + new Date().getTime() + "&bqid=" + this.bqid).then(res => {
                    // this.sqr = res.data
                    window.sessionStorage.setItem("sqrlist",JSON.stringify(res.data))
                    //代码值特殊处理
                    res.data && res.data.map((item) => {
                        // if(item.cGh == '--'){
                        //     item.cGh = ''
                        // }
                        // if(item.cSqrlx == 1){
                        //     this.sqrlx = typeRylx(item.cSqrlx)
                        // }else if(item.cSqrlx == 2){
                        //     this.sqrlx2 = typeRylx(item.cSqrlx)
                        //     this.dwxz1 = typeGzdwlx(item.cDwxz)
                        // }else if(item.cSqrlx == 3){
                        //     this.sqrlx3 = typeRylx(item.cSqrlx)
                        //     this.dwxz2 = typeGzdwlx(item.cDwxz)
                        // }
                        // this.Sfzjlx = typeSfzjlx(item.cZjlx)
                        // this.mz = typeMz(item.nMz)
                        let temp = {
                            cDwxz:typeGzdwlx(item.cDwxz),
                            cGh:item.cGh,
                            cPhoneno:item.cPhoneno,
                            cQyfr:item.cQyfr,
                            cQymc:item.cQymc,
                            cQyzch:item.cQyzch,
                            nZzlxText:typeZzlx(item.nZzlx),
                            cQyzzjgdm:item.cQyzzjgdm,
                            cSqrlx:typeRylx(item.cSqrlx),
                            cSqrlx1:item.cSqrlx,
                            cSqrxb:typeXb(item.cSqrxb),
                            cSqrxm:item.cSqrxm,
                            cTxdz:item.cTxdz,
                            cZjh:item.cZjh,
                            cZjlx:typeSfzjlx(item.cZjlx),
                            dtSqrBirthday:item.dtSqrBirthday,
                            nMz:typeMz(item.nMz),
                            nNl:item.nNl,
                        }
                        this.sqr.push(temp)
                    })

                })

            }
        },
        created() {
            this.getSqrList()
        }
    }
</script>